

import {AfterContentChecked , AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges,} from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { environment } from '../../../../environments/environment';

@Directive({
  selector: '[typeDisplay]',
})
export class TypeDisplayDirective implements OnChanges, AfterViewInit  {

  @Input('typeDisplay') typeDisplay;
  @Input('rowIndex') rowIndex;
  @Input('prefix') prefix;
  @Input('cellData') cellData;

  constructor(
    private element: ElementRef<HTMLElement>,
    private common: CommonService
  ) {
   }
  ngOnChanges(changes: SimpleChanges): void { }
  ngAfterViewInit (): void {
    let innerText = this.element.nativeElement;
    if (this.typeDisplay == 'date') {
      innerText.innerText = this.common.anyToDate(innerText.innerText,'DD/MM/YYYY');
    } else if (this.typeDisplay == 'stt') {
      innerText.innerText = this.rowIndex + 1;
    } else if (this.typeDisplay == 'image') {
      innerText.innerText = '';
      let imgs = JSON.parse(this.cellData);
      imgs.forEach(img => {
        let linkEl = document.createElement('a');
        let imgel = document.createElement('img');
        imgel.src = `${environment.apiUrlHrm}files/${img.id}/download`
        linkEl.href = `${environment.apiUrlHrm}files/${img.id}/download`
        imgel.width = 25;
        linkEl.appendChild(imgel);
        innerText.appendChild(linkEl);

      })
    } else if (this.typeDisplay == 'wrapHtml') {
      innerText.innerText = this.cellData;
    } else if (this.typeDisplay == 'degree') {
      let degree = Math.floor(this.cellData / 3600);
      let minute = Math.floor((this.cellData - degree * 3600) / 60);
      let second =this.cellData - degree * 3600 - minute * 60;
      innerText.innerText = `${degree}°${minute}'${second}"`
    }
    if (this.prefix) {
      innerText.innerText = this.prefix + innerText.innerText;
    }
  }
}

